<svg
  width="25"
  height="26"
  viewBox="0 0 25 26"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_86_694)">
    <rect
      x="6.77936"
      y="7.27935"
      width="11.4413"
      height="11.4413"
      rx="5.72064"
      stroke="currentColor"
      stroke-width="1.75"
      stroke-miterlimit="10"
    />
    <path
      d="M12.5956 10.96V13.0804L14.9028 15.0329"
      stroke="currentColor"
      stroke-width="1.75"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
  </g>
  <defs>
    <clipPath id="clip0_86_694">
      <rect width="25" height="25" fill="white" transform="translate(0 0.5)" />
    </clipPath>
  </defs>
</svg>
